import React from "react";

export default function Button({ className, btnName, ...props }) {
  return (
    <div className={className}>
      <button {...props}>{btnName}</button>
    </div>
  );
}
